/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Network_LedeInputs */

const en_endpoint_network_lede = /** @type {(inputs: Endpoint_Network_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The cheapest provider serves first. If it fails, the next one takes over in the same call.`)
};

const zh_hans1_endpoint_network_lede = /** @type {(inputs: Endpoint_Network_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最便宜的服务商优先响应。如果它失败，下一个会在同一次调用中接手。`)
};

const pt_br2_endpoint_network_lede = /** @type {(inputs: Endpoint_Network_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O provedor mais barato atende primeiro. Se ele falhar, o próximo assume na mesma chamada.`)
};

const es_endpoint_network_lede = /** @type {(inputs: Endpoint_Network_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El proveedor más barato responde primero. Si falla, el siguiente toma el relevo en la misma llamada.`)
};

const fr_endpoint_network_lede = /** @type {(inputs: Endpoint_Network_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le fournisseur le moins cher répond en premier. S’il échoue, le suivant prend le relais dans le même appel.`)
};

const de_endpoint_network_lede = /** @type {(inputs: Endpoint_Network_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der günstigste Anbieter bedient zuerst. Fällt er aus, übernimmt der nächste im selben Aufruf.`)
};

const ru_endpoint_network_lede = /** @type {(inputs: Endpoint_Network_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Первым обслуживает самый дешёвый поставщик. Если он не отвечает, его заменяет следующий в том же вызове.`)
};

const it_endpoint_network_lede = /** @type {(inputs: Endpoint_Network_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serve per primo il provider più economico. Se fallisce, subentra il successivo nella stessa chiamata.`)
};

/**
* | output |
* | --- |
* | "The cheapest provider serves first. If it fails, the next one takes over in the same call." |
*
* @param {Endpoint_Network_LedeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_network_lede = /** @type {((inputs?: Endpoint_Network_LedeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Network_LedeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_network_lede(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_network_lede(inputs)
	if (locale === "es") return es_endpoint_network_lede(inputs)
	if (locale === "fr") return fr_endpoint_network_lede(inputs)
	if (locale === "de") return de_endpoint_network_lede(inputs)
	if (locale === "ru") return ru_endpoint_network_lede(inputs)
	if (locale === "it") return it_endpoint_network_lede(inputs)
	return en_endpoint_network_lede(inputs)
});